import { render, staticRenderFns } from "./ind.vue?vue&type=template&id=1b05e865&scoped=true&"
import script from "./ind.vue?vue&type=script&lang=ts&"
export * from "./ind.vue?vue&type=script&lang=ts&"
import style0 from "./ind.vue?vue&type=style&index=0&id=1b05e865&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b05e865",
  null
  
)

export default component.exports